"use client";

import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@retailos/core";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, id, ...props }, ref) => {
    const textareaId = id || label?.toLowerCase().replace(/\s+/g, "-");

    return (
      <div className="space-y-2">
        {label && (
          <label htmlFor={textareaId} className="block text-sm font-medium text-white/70">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={cn(
            "w-full rounded-xl border bg-surface px-4 py-3 text-base text-white placeholder:text-text-dim",
            "transition-all duration-200 min-h-[100px] resize-y",
            "focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-surface-border-2",
            error ? "border-danger/50" : "border-surface-border",
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs text-danger">{error}</p>}
      </div>
    );
  },
);

Textarea.displayName = "Textarea";
